import { useNavigate } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';

import styles from './stylesReviewRulesLink.module.css';

import { NAVIGATION_ROUTES } from '../../../../utils/NavigationUtils';
import { useWithdrawalReview } from '../WithdrawalReviewContext';

function ReviewRulesLink() {
  const navigate = useNavigate();

  const { withdrawalRules } = useWithdrawalReview();

  const handleClick = () => {
    navigate(NAVIGATION_ROUTES.WITHDRAWAL_REVIEW_RULES);
  };

  return (
    <div>
      <button onClick={handleClick} className={styles.button}>
        <div>
          <span className={styles.ruleCount}>
            {withdrawalRules?.rules.length}
          </span>
        </div>
        <span>Withdrawal Review Rules</span>
        <RightOutlined />
      </button>
    </div>
  );
}

export default ReviewRulesLink;
